import { FC } from "react";
import { JourneyStep } from "./types";
import { Button } from "@/components/UI/Buttons/Button";

interface MembershipJourneyProps {
  title: string;
  journey: JourneyStep[];
  isDark: boolean;
  bgClass: string;
  textClass: string;
  maxVisibleSteps?: number;
  onMoreClick?: () => void;
  moreLabel?: string;
}

const MembershipJourney: FC<MembershipJourneyProps> = ({
  title,
  journey,
  isDark,
  bgClass,
  textClass,
  maxVisibleSteps,
  onMoreClick,
  moreLabel = "Plačiau",
}) => {
  const filteredSteps = journey.filter((step) =>
    isDark ? step.apex : step.core,
  );
  const visibleSteps =
    typeof maxVisibleSteps === "number"
      ? filteredSteps.slice(0, Math.max(0, maxVisibleSteps))
      : filteredSteps;
  const hasMore =
    typeof maxVisibleSteps === "number" &&
    filteredSteps.length > maxVisibleSteps;

  return (
    <div
      className={`${bgClass} flex w-full flex-col gap-[30px] rounded-[26px] p-6 md:p-[60px]`}
    >
      <h4 className={`text-[20px] font-medium md:text-[24px] ${textClass}`}>
        {title}
      </h4>
      <div className="flex w-full flex-col">
        <div className="relative">
          {visibleSteps.map((step, i, arr) => {
            const label = "timeLabel" in step ? step.timeLabel : step.introLabel;
            const prevStep = arr[i - 1];
            const isDuplicateTimeLabel =
              "timeLabel" in step &&
              Boolean(prevStep) &&
              "timeLabel" in prevStep &&
              step.timeLabel === prevStep.timeLabel;

            const nextStep = arr[i + 1];
            const nextLabel = nextStep
              ? "timeLabel" in nextStep
                ? nextStep.timeLabel
                : nextStep.introLabel
              : null;

            const showDivider = Boolean(nextStep) && label !== nextLabel;

            return (
              <div key={i} className="flex w-full flex-col gap-6">
                <div className="flex w-full items-start gap-5 pt-6">
                  <img
                    src={step.img}
                    alt={step.title}
                    className="h-[70px] w-[70px] shrink-0 rounded-md object-cover md:h-[90px] md:w-[90px]"
                />
                <div className="flex min-w-0 flex-1 flex-col gap-2.5">
                  <div className="flex w-full flex-col items-start gap-1.5">
                    {step.introLabel || !isDuplicateTimeLabel ? (
                      <div
                        className={`flex shrink-0 items-center justify-center ${step.introLabel ? "" : "rounded-full bg-white px-[14px] py-[4px]"} `}
                      >
                        <span
                          className={`leading-[1.2] ${
                            step.introLabel
                              ? isDark
                                ? "text-base font-medium text-white md:text-xl"
                                : "text-base font-medium text-gray-900 md:text-xl"
                              : "text-base text-gray-900"
                          }`}
                        >
                          {step.introLabel || step.timeLabel}
                        </span>
                      </div>
                    ) : null}
                    <h5
                      className={`text-[18px] font-medium md:text-[20px] ${textClass}`}
                    >
                      {step.title}
                    </h5>
                    </div>
                    <p
                      className={`text-[15px] leading-[1.5] md:text-[16px] ${textClass}`}
                    >
                      {step.description}
                    </p>
                  </div>
                </div>
                {showDivider && (
                  <div className="w-full border-b border-dashed border-[#B7B7B7]"></div>
                )}
              </div>
            );
          })}
        </div>

        {hasMore && (
          <div className="mt-6 flex w-full justify-center">
            <Button
              type="button"
              variant="white"
              size="sm"
              className="w-auto min-w-[188px] text-base"
              onClick={() => onMoreClick?.()}
              onHover
              hoverDark
            >
              {moreLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MembershipJourney;
